<section class="cz-end-user-agreement-component">
  <mat-dialog-title class="mat-dialog-title">
    <div class="row">
      <div class="col-xs-10">
        <h3 class="title" [innerHTML]="'$login_end_user_agreement_label' | translate"></h3>
      </div>
      <div class="col-xs-2 end-xs">
        <button mat-button (click)="logout()" class="mat-dialog-back-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-title>
  <mat-dialog-content>
    <div [innerHTML]="'$login_end_user_agreement_content' | translate"></div>
    <p *ngIf="agreementDeclined" class="agreement-declined-message">{{'$login_user_agreement_declined_message' |
      translate}}</p>
    <div class="row bottom-buttons">
      <div class="col-xs-6">
        <button mat-flat-button color="accent" (click)="downloadPDF()">Download as PDF</button>
      </div>

      <div class="col-xs-6 end-xs" *ngIf="loggedInUser">

        <button mat-stroked-button color="accent" class="mx-2" (click)="declineAgreement()"
          [innerHTML]="'$login_user_privacy_policy_btn_decline' | translate"></button>

        <button mat-flat-button color="accent" (click)="acceptAgreement()"
          [innerHTML]="'$login_user_privacy_policy_btn_accept' | translate"></button>

      </div>

    </div>
  </mat-dialog-content>
</section>